import React, { useRef, useEffect, useCallback } from "react";
import { useTheme, Theme, makeStyles } from "@material-ui/core/styles";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

interface ICircleChart {
  name: string;
  value: number;
  max: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: { height: "100%" },
}));

const CircleChart = (props: ICircleChart) => {
  const classes = useStyles();
  const theme = useTheme();
  const chartRef = useRef<any>(null);

  const initChart = useCallback(() => {
    const chart: any = am4core.createFromConfig(
      {
        data: [{ ...props }],
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        startAngle: -90,
        endAngle: 270,
        innerRadius: am4core.percent(75),
        yAxes: [
          {
            type: "CategoryAxis",
            id: "yAxes",
            dataFields: { category: "name" },
            tooltip: {
              disabled: true,
            },
            renderer: {
              grid: {
                template: {
                  location: 0,
                  strokeOpacity: 0,
                },
              },
              labels: {
                disabled: true,
              },
              minGridDistance: 10,
            },
          },
        ],
        xAxes: [
          {
            type: "ValueAxis",
            id: "xAxes",
            tooltip: {
              disabled: true,
            },
            renderer: {
              grid: {
                template: {
                  strokeOpacity: 0,
                },
              },
              labels: { disabled: true },
            },
            min: 0,
            max: 100,
            strictMinMax: true,
          },
        ],
        radarContainer: {
          text: "value",
          fontSize: "1rem",
          horizontalCenter: "middle",
          verticalCenter: "middle",
        },
        series: [
          {
            type: "RadarColumnSeries",
            dataFields: {
              valueX: "value",
              categoryY: "name",
            },
            clustered: false,
            columns: {
              template: {
                strokeWidth: 0,
                fill: am4core.color(theme.palette.primary.main),
                radarColumn: {
                  cornerRadius: 20,
                },
              },
            },
            tooltip: {
              disabled: true,
            },
          },
          {
            type: "RadarColumnSeries",
            dataFields: {
              valueX: "max",
              categoryY: "name",
            },
            clustered: false,
            columns: {
              template: {
                strokeWidth: 0,
                radarColumn: {
                  cornerRadius: 20,
                },
                fill: new am4core.InterfaceColorSet().getFor(
                  "alternativeBackground"
                ),
                fillOpacity: 0.08,
              },
            },
            tooltip: {
              disabled: true,
            },
          },
        ],
        // cursor: {
        //   type: "RadarCursor",
        // },
      },
      chartRef ? chartRef.current : "",
      am4charts.RadarChart
    );
    let title = chart.radarContainer.createChild(am4core.Label);
    title.text = `${chart.data[0].value} %`;
    title.fontSize = "1.5rem";
    title.id = "radarContainer";
    title.fontWeight = 600;
    title.fill = "#000";
    title.horizontalCenter = "middle";
    title.verticalCenter = "middle";
  }, [theme, props]);

  useEffect(() => {
    initChart();
    return () => {};
  }, [initChart]);
  return <div ref={chartRef} className={classes.root}></div>;
};

export default CircleChart;
